module.exports = __webpack_public_path__ + "img/heading3.3be33fb5.png";